// removed by extract-text-webpack-plugin
module.exports = {"header":"Picklists__header___1IjUC","customer":"Picklists__customer___28KcQ","date":"Picklists__date___2eX4L","route":"Picklists__route___3PddI","caption":"Picklists__caption___2XNPA","table":"Picklists__table___8RTMH","left":"Picklists__left___1tFdn","center":"Picklists__center___1Pnnz","nowrap":"Picklists__nowrap___3nZZv","picklist":"Picklists__picklist___2D8-u"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Reports/Shellfish/Picklists/Picklists.scss
// module id = 1250
// module chunks = 1